import React from 'react'

type DayLengthTextProps = {
  day_length?: 'FULL' | 'HALF_AM' | 'HALF_PM' | 'OVERNIGHT' | null
}

export const DayLengthText: React.FC<DayLengthTextProps> = ({ day_length }) => {
  const getDayLengthInfo = (dayLength?: 'FULL' | 'HALF_AM' | 'HALF_PM' | 'OVERNIGHT' | null) => {
    switch (dayLength) {
      case 'FULL':
        return 'Full day'
      case 'HALF_AM':
        return '½ day AM'
      case 'HALF_PM':
        return '½ day PM'
      case 'OVERNIGHT':
        return 'Overnight'
      default:
        return 'Unknown day length'
    }
  }

  return <span data-testid="day-length-label">{getDayLengthInfo(day_length)}</span>
}
